var url = {
  // baseUrl: "http://35.82.80.61/gateway",
  // baseUrl: "https://ud2.udreamed.com/gateway",
  baseUrl: "https://udreamed.com/gateway/",
  // baseUrl : 'http://sandbox.com/gateway'
};

export default url;
